import { render } from "./InterfaceSidebar.vue?vue&type=template&id=0afde10c&scoped=true"
import script from "./InterfaceSidebar.vue?vue&type=script&lang=js"
export * from "./InterfaceSidebar.vue?vue&type=script&lang=js"

import "./InterfaceSidebar.vue?vue&type=style&index=0&id=0afde10c&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afde10c"]])

export default __exports__